import { UilCircle } from '@iconscout/react-unicons';
import { 
  UilUserCircle,
  UilBox,
  UilLocationPoint,
  UilCreditCard
} from '@iconscout/react-unicons';

import { Menu } from 'antd';
import React from 'react';
// import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import propTypes from 'prop-types';

function MenuItems({ toggleCollapsed }) {
  // const { t } = useTranslation();

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const { topMenu } = useSelector((state) => {
    return {
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });

  const path = '/admin';

  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split('/');

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  const items = [
    // getItem(
    //   <NavLink onClick={toggleCollapsed} to={`${path}/pages/starter`}>
    //     Blank Page
    //   </NavLink>,
    //   'starter',
    //   !topMenu && (
    //     <NavLink className="menuItem-iocn" to={`${path}/pages/starter`}>
    //       <UilCircle size="30" />
    //     </NavLink>
    //   ),
    // ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/pages/profile`}>
        โปรไฟล์ของฉัน
      </NavLink>,
      'profile',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/pages/profile`}>
          <UilUserCircle size="30" />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/pages/shipping`}>
        พัสดุของฉัน
      </NavLink>,
      'shipping',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/pages/shipping`}>
          <UilBox size="30" />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/pages/address`}>
        ที่อยู่ของฉัน
      </NavLink>,
      'address',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/pages/address`}>
          <UilLocationPoint size="30" />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/pages/cod`}>
        COD ของฉัน
      </NavLink>,
      'cod',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/pages/cod`}>
          <UilCreditCard size="30" />
        </NavLink>
      ),
    )
  ];

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
              `${
                mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
              }`,
            ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<UilEllipsisV />}
      openKeys={openKeys}
      items={items}
    />
  );
}

MenuItems.propTypes = {
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
